import { AnimatePresence, motion } from 'motion/react';
import { AnimatedMark } from '@/components/brand/triangle-motif';

/** Full-screen cover while the app swaps between the platform and a support session. */
export function SessionSwitchOverlay({ message }: { message: string | null }) {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          key="switch"
          role="status"
          aria-live="polite"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[70] flex flex-col items-center justify-center gap-5 bg-bg/90 backdrop-blur-sm"
        >
          <motion.div
            animate={{ scale: [1, 1.06, 1] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          >
            <AnimatedMark className="size-14" />
          </motion.div>
          <p className="text-sm text-fg-muted">{message}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
